import { render, staticRenderFns } from "./NewAndRenewals.vue?vue&type=template&id=5f1df33e&scoped=true&"
import script from "./NewAndRenewals.vue?vue&type=script&lang=js&"
export * from "./NewAndRenewals.vue?vue&type=script&lang=js&"
import style0 from "./NewAndRenewals.vue?vue&type=style&index=0&id=5f1df33e&lang=scss&scoped=true&"
import style1 from "./NewAndRenewals.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1df33e",
  null
  
)

export default component.exports